import {
  FILTER_TYPES,
  MODEL_TYPES,
  PRODUCT_CATEGORY,
  PROGRESS_BAR_TYPES,
  REMOVE_SORT_PARAM_ROUTES,
  RENDER_STATUS,
  REQUEST_STATUSES,
  SENTRY_ERROR_TYPES,
  STATUS_BLENDER_PROCESSING_KEY,
  STATUS_DISABLED_KEY,
  STATUS_DONE_KEY,
  STATUS_FAILED_KEY,
  STATUS_INFECTED_KEY,
  STATUS_NOT_DONE_KEY,
  STATUS_PROCESSING_KEY,
  TEXTURE_CATEGORY,
  THREE_D_FILE_DOWNLOADS,
  THUMBNAIL_MAX_RESOLUTION,
  USERPILOT_UUID,
  frequency,
} from '../constants/constants';
import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2,
  LOGIN_HOME,
  NEW_REQUEST_ROUTE,
  RENDERS_PREVIEWS_ROUTE_V2,
  SIGNUP_ROUTE,
} from '../constants/routePathConstants';
import { CURRENT_USER, NO_BRAND_TAG_ORG, TITLE_PREFIX } from '../constants/projectConstants';
import { RENDER_IMAGE_TYPE } from '../constants/renderPreviewConstants';
import { ACTION } from '../common/ThumbnailCardUI.js';
import { CM_IN_ONE_INCHES } from '../config/constant/unityConstants';
import { CollectFilesIcon } from '../assets/icons.js';
import { DEFAULT_DPI } from '../constants/textureConstants';
import { NAME_EXCLUDED_SPECIAL_CHARS_GLOBAL } from '../constants/validationConstants';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { apiErrorHandler } from './axiosHelper';
import axios from 'axios';
import clone from 'lodash/clone';
import { errorToast, errorToastV2, successToast, warningToast } from './toastHelper';
import fileDownload from 'downloadjs';
import { dispatcher, isDev, navigate } from './projectHelper.js';
import moment from 'moment';
import setWith from 'lodash/setWith';
import {
  LF_DEBUGGER,
  LF_DEBUGGER_HUBSPOT,
  RESTRICTED_EMAILS,
} from '../config/constant/projectConstant.js';
import differenceInDays from 'date-fns/differenceInDays';
import { convertBytesInMB, toUnityFixed } from './unityHelper.js';
import {
  sendRenderForAutomation,
  sendRenderForAutomation360,
  sendRenderForAutomationManualSelectionTemplates,
} from './textureModelUploadHelper.js';
import * as piexif from 'piexifjs';
import ExifTool from 'exiftool.js';
import { apiPost3DModelJob } from './api.js';
import Switch from '../components/admin/switch/index.js';
import {
  setShowPopupBlockModal,
  setShowPopupBlockModalActions,
  setUseCacheInAPI,
} from '../redux/slicers/appSlicer.js';
import * as Sentry from '@sentry/react';
import { isPublicPageView } from '../components/Configurator/utils/index.js';
import { openInfoDialog } from '../hooks/useInfoDialogaActions.js';
import { setEnterpriseFormDialogOpen } from '../redux/slicers/subscriptionSlicer.js';
import { getAndSetCookieData } from './apiHelper.js';
import { RESTRICTED_EMAIL_DOMAIN } from '../common/Mixpanel.js';
import UTIF from 'utif';
import FileUploadIcon from '../components/icons/FileUploadIcon.js';
import { setUpdateJsonModalData } from '../redux/slicers/render_preview/myRenderPreviewSlice.js';

export const setTitle = (title) => {
  if (title) {
    document.title = title + ' - ' + TITLE_PREFIX;
  }
};
export const arrayRemoveIndex = (arr, ind) => arr.filter((_, index) => index !== ind);
export const arrayRemove = (arr, key, val) => arr.filter((a) => a[key] !== val);
export const duplicateArrayRemove = (arr) => arr.filter((a, i) => arr.indexOf(a) === i);
export const checkValueExists = (a = {}) => Object.entries(a).some(([k, v]) => !!v);

export const reload = () => window.location.reload();

export const parseFloatNaN = (a) => (isNaN(a) || a === '' ? 0 : parseFloat(a));

export const spaceReduce = (a) => (a ? a.split(' ').join('_') : '');
export const spaceReverse = (a) => (a ? a.split('_').join(' ') : '');

export function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
}

export const objectFind = (a, key, select) => {
  const res = a.find((i) => i[key] === select);
  if (res) {
    return Object.assign({}, res);
  }
  return {};
};

export const objectGetValue = (a, key, select, value) => {
  const res = a.find((i) => i[key] === select);
  if (res) {
    return res?.[value] ?? null;
  }
  return null;
};

export const objectRemoveUndefined = (obj) =>
  Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});

export const objectFindCheck = (a, key, select) => a.findIndex((i) => i[key] === select) > -1;

export const objectFindUpdate = (a = null, key, select, res) => {
  if (!a) {
    return null;
  }
  let arr = [...a];
  let ind = arr.findIndex((i) => i[key] == select);
  arr[ind] = { ...arr[ind], ...res };
  return [...arr];
};

export const objectToSearchParams = (obj) => {
  if (obj) {
    const searchParams = new URLSearchParams(objectRemoveUndefined(obj));
    return searchParams;
  }
  return '';
};

export const searchStrToObj = (str) => {
  const s = new URLSearchParams(str);
  return Object.fromEntries(s);
};

export const objectToFormData = (obj, { ignoreUndefined = false, separateArrayItems } = {}) => {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    if (ignoreUndefined && typeof value === 'undefined') return;

    if (_.isArray(value)) {
      if (separateArrayItems) {
        value.forEach((v) => formData.append(key, v));
        return;
      } else {
        value = `${value}`;
      }
    }

    if (value instanceof File) {
      formData.append(key, value, value?.name || undefined);
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

export const uniqueId = () => `${Date.now()}${Math.random()}`;

export const arrayUpsert = (data = [], key, value, obj) => {
  let newData = data;
  if (objectFindCheck(data, key, value)) {
    newData = objectFindUpdate(data, key, value, obj);
  } else {
    newData.unshift(obj);
  }
  return newData;
};
export const lookupArray = (array) =>
  Object.assign({}, ...array.map((i) => ({ [i.value]: i.text })));
export const arrayMapKeyValue = (arr, key, value) => arr.map((i) => ({ [key]: i[value] }));
export const optionArray = (array, val, text) =>
  array.map((i) => ({ value: i[val], text: i[text], ...i }));
export const optionAutoComplete = (array = [], label) =>
  array.map((i) => ({ label: i[label] ?? null })).filter((i) => i.label);
export const arrayAutoComplete = (array = []) => array.map((i) => ({ label: i }));

export const arrayToOption = (arr = []) =>
  arr.flatMap((val, ind) => (val ? { text: val, value: ind } : []));

export const timeRender = (a = null) => (a ? moment(a).format('MMM-DD-YYYY hh:mm A') : null);

export const capitalize = (a) => (a ? a.toString().split('')[0].toUpperCase() + a.slice(1) : '');

export const ToAge = (a) => Math.round(moment.duration(a).asYears());
export const dateRender = (a) => moment(a).format('MM-DD-YYYY');

export const ToYear = (a) => moment(a).format('YYYY');
export const createdTime = (a) => moment(a).format('MMM DD, YYYY ');
export const ToDate = (a) => {
  if (a === undefined || a === null) return null;
  return moment(a).format('MM-DD-YYYY');
};

export const updateToArrayLoop = (a = [], obj) => a.map((i) => Object.assign(i, obj));
export const freezeClone = (a = {}) => JSON.parse(JSON.stringify(a));
export const sum = (a, key) =>
  a
    .reduce((acc, b) => {
      if (b[key]) {
        acc = acc + parseFloatNaN(b[key]);
      }
      return acc;
    }, 0)
    .toFixed(2);

export const windowOpen = (link, target = '_self') => {
  window.open(link, target);
};
export const windowOpenV2 = (link, target = '_self') => {
  const isOpened = window.open(link, target);
  if (!isOpened) {
    dispatcher(setShowPopupBlockModal(true));
    window.popupBlockerModalLink = link;
    window.popupBlockerModalTarget = target;
  }
};
export const hashOpen = (link = null) => {
  window.open(`#${link}`);
};

export const scrollToBottom = (elem) => {
  if (elem?.scrollHeight) {
    elem.scrollTop = elem.scrollHeight;
  }
};

export const isFalsyExcept0 = (val) => !val && val !== 0;

export const duplicateRemove = (arr, key) => {
  return arr
    .map((a) => a[key])
    .filter((a, ind, ar) => ind === ar.indexOf(a))
    .reduce((acc, curr) => (acc.push({ [key]: curr }), acc), []);
};

export const removeDuplicatesByKey = (array, key) => {
  const uniqueMap = new Map();

  if (array.length === 0) {
    return array;
  }

  // Iterate through the array of objects
  array.forEach((item) => {
    // Use the specified key to determine uniqueness
    const keyValue = item[key];

    // If the key value is not in the map, add the object to the map
    if (!uniqueMap.has(keyValue)) {
      uniqueMap.set(keyValue, item);
    }
  });

  // Convert the map values back to an array
  const uniqueArray = Array.from(uniqueMap.values());

  return uniqueArray;
};

export const NumGen = (length) => Array.from(Array(length), (_, ind) => ind);

export const timeRandomName = (a = 'upload') => {
  const suf =
    moment().format('MM_DD_YYYY_HH_mm') + Math.round(Math.random() * 100000000).toString();
  return a + '_' + suf;
};

export const strReduce = (str, length = 30) => {
  return str.substr(0, length);
};

export const yearToMilliseconds = (a) => parseInt(moment(a).format('x'));

export const timeRenderStrToDate = (a = null) => (a ? moment(a, 'x').format('MMM-DD-YYYY') : null);
export const timeRenderStrToTime = (a = null) => (a ? moment(a, 'x').format('hh:mm A') : null);

export const dateToMilli = (a) => {
  const ts = moment(a).unix();
  const s = moment.unix(ts);
  return s;
};

export const hourString = (a) => {
  if (a.toString().includes('.')) {
    const s = a.toString().split('.');
    return s[0] + ' Hour' + ' ' + s[1] + ' Min';
  } else {
    return a + ' Hour';
  }
};

export const getDateLeftFromDate = ({ date = null, daysToBeAdded = 0 }) => {
  let daysLeft = daysToBeAdded;
  if (date) {
    const finalDate = new Date(date);
    finalDate.setDate(finalDate.getDate() + daysToBeAdded);
    daysLeft = finalDate.getTime() <= Date.now() ? 0 : differenceInDays(finalDate, Date.now()) + 1;
  }
  return daysLeft;
};

export const duplicateRemoveArrayObj = (ar, key) => {
  const res = [];
  ar?.forEach((a, i) => {
    const ind = ar.findIndex((k) => k[key] === a[key]);
    if (ind === i) {
      if (Object.keys(a).length > 0) {
        res.push(a);
      }
    }
  });
  return res;
};

export const toFixed = (a = '0') => {
  return +Number(a).toFixed(2);
};

export const parseHTML = (html) => {
  const str = new DOMParser().parseFromString(html, 'text/html');
  return str.body.textContent;
};

export const sliceString = (data) => {
  if (data.length > 100) {
    return data.slice(0, 100) + '...';
  }
  return data;
};

export const perfectNumber = (a = '') => {
  return a ? (isNaN(Number(a)) ? 0 : Number(a)) : 0;
};

export const currencyConvert = (num = null) => {
  return Number(num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
};

export const devConsoleLog = (...a) => {
  if (a) {
    if (isDev()) {
      console.log(...a);
    }
  }
};

export const getLocalStorage = (key = '', tryParseJson = false) => {
  let results;
  try {
    results =
      key && !_.isNil(window.localStorage.getItem(key)) ? window.localStorage.getItem(key) : null;
    if (results && tryParseJson) {
      results = JSON.parse(results);
    }
  } catch (e) {
    console.log(`error getting ${key} from localStorage`, e);
  }
  return results;
};

export const getSessionStorage = (key = '', tryParseJson = false) => {
  let results;
  try {
    results =
      key && !_.isNil(window.sessionStorage.getItem(key)) ? window.localStorage.getItem(key) : null;
    if (results && tryParseJson) {
      results = JSON.parse(results);
    }
  } catch (e) {
    console.log(`error getting ${key} from localStorage`, e);
  }
  return results;
};

export const setLocalStorage = (key = '', str = '') => {
  if (_.isObject(str)) {
    str = JSON.stringify(str);
  }
  return window.localStorage.setItem(key, str);
};

export const setSessionStorage = (key = '', str = '') => {
  if (_.isObject(str)) {
    str = JSON.stringify(str);
  }
  return window.sessionStorage.setItem(key, str);
};

export const removeLocalStorage = (key = '') => {
  return window.localStorage.removeItem(key);
};

export const removeSessionStorage = (key = '') => {
  return window.sessionStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  return window.localStorage.clear();
};

export const clearSessionStorage = () => {
  return window.sessionStorage.clear();
};

export const checkJson = (str) => {
  try {
    var o = JSON.parse(str);
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {
    console.log('Json error');
  }
  return false;
};

export const getCommonMetadata = (list, pageNumber, totalPages) => {
  return {
    total: list && list.length,
    hasData: list && list.length > 0,
    anySelected: _.some(list, (item) => item.selected),
    allSelected: list.length > 0 && _.every(list, (item) => item.selected),
    selectedList: _.filter(list, (item) => item.selected),
    hasMore: pageNumber < totalPages,
  };
};

export const isValidNumber = (num) => {
  return typeof num === 'number' && !Number.isNaN(num);
};

export const stripTags = (str) => {
  return str.replace(/<(?:.|\n)*?>/gm, '');
};

export const stripNonNumbersFullRange = (str) => {
  return str.replace(/[^0123456789\-\.]/g, '');
};

export const stripNonIntegerFullRange = (str) => {
  return str.replace(/[^0123456789\-]/g, '');
};

export const stripNonNumbers = (str) => {
  return str.replace(/[^0123456789\.]/g, '');
};

export const stripNonInteger = (str) => {
  return str.replace(/[^0123456789]/g, '');
};

export const decimals = (num, count) => {
  const m = Math.pow(10, count);
  return Math.round(num * m) / m;
};

export const countDecimals = function (value) {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
};

export const truncateDecimals = (num, digits) => {
  const factor = Math.pow(10, digits);
  const value = Math.floor(num * factor) / factor;
  return isNaN(value) ? 0 : value;
};

export const calculateProgress = (loaded, total) => {
  return Math.min(Math.floor((loaded / total) * 100), 100);
};

function addQueryParams(queryString, value, label) {
  if (value && !_.includes(['', null, undefined], value)) {
    let addAmpersand = queryString === '' ? '' : '&';
    return `${queryString}${addAmpersand}${label}=${value}`;
  }
  return '';
}

export const constructQueryParams = (
  sortField,
  filters,
  pageNumber,
  globalFilters,
  teamMembers
) => {
  let params = '';
  if (sortField) {
    // value may be a selected object from <Select>
    // so will use the value of that object if possible
    if (sortField?.value) {
      sortField = sortField.value;
    }
    params = `sort=${sortField}`;
  }
  if (globalFilters) {
    _.mapKeys(globalFilters, (filterItem, key) => {
      if (key === FILTER_TYPES.FAVOURITE) {
        if (filterItem === true) {
          params = addQueryParams(params, true, FILTER_TYPES.FAVOURITE);
        }
      } else if (key === FILTER_TYPES.ORDERED_FILTERS) {
        // orderedFilters are an array of filters
        _.forEach(filterItem, (filter) => {
          if (filter) {
            let { filter_label_id, list } = filter;
            if (_.isArray(list) && list.length > 0) {
              const idArray = [];
              _.map(list, (item) => {
                if (item.selected) {
                  idArray.push(item.id);
                }
              });
              if (idArray.length > 0) {
                // fl_label is only for filteroptions and is shaped like this fl_18 or fl_14
                // for the id of the filter label
                // but the field here is the text visible to the user
                // so the actual name of the filter label
                // need first item on filter
                params = addQueryParams(
                  params,
                  _.join(idArray, ','),
                  filter_label_id ? `fl_${filter_label_id}` : filter.key
                );
              } else {
                // console.log('unknown query param key', filter.key)
              }
            } else {
              // if you've gotten here it's because one of the filtering scenarios has not been accounted for above
              // console.log('unknown query param key', key)
              // _.mapKeys(filter, (list, type) => {
              //   console.log(`filter${type}`, list);
              // });
            }
          }
        });
      }
    });
  }
  if (teamMembers && teamMembers.length) {
    let members = [];
    _.map(teamMembers, (member) => {
      if (member.selected) {
        members.push(member.id);
      }
    });
    if (members && members.length > 0) {
      params = addQueryParams(params, members.join(','), FILTER_TYPES.CREATED_BY);
    }
  }

  const paramsArr = params.split('&');
  // console.log("before params split: ", paramsArr)
  const tempPop = paramsArr.shift();
  paramsArr.push(tempPop);
  // console.log("after params split: ", paramsArr)

  params = paramsArr.join('&');
  // console.log("params: ", params)

  if (filters && filters.length) {
    _.map(filters, (filter) => {
      let { label, value } = filter;
      // value may be a selected object from <Select>
      // so will use the value of that object if possible
      if (value?.value) {
        value = value.value;
      }
      if (_.isObject(value)) {
        value = value.value;
      }
      if (value) {
        params = addQueryParams(params, value, label);
      }
    });
  }
  if (pageNumber) {
    params = addQueryParams(params, pageNumber, FILTER_TYPES.PAGE);
  }

  return params;
};

export const addValueLabelToList = (list) => {
  return _.map(list, (item) => {
    item.value = item.id;
    item.label = item.name;
    return item;
  });
};

export const updateByPath = (obj, path, value) => {
  return setWith(clone(obj), path, value, clone);
};

export const reversKeyValue = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});
};

export const emailIsValid = (email) => {
  var emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return emailRegex.test(email);
};

export const passwordIsValid = (password) => {
  var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@[-`{-~]).{8,64}$/;
  return passwordRegex.test(password);
};

export const pwdMatchCheck = (a, b) => {
  return a === b;
};

export const wait = async (durationMs = 0) => {
  return new Promise((resolve) => setTimeout(resolve, durationMs));
};

export const waitRandom = async (minMs = 0, maxMs = 1000) => {
  const durationMs = parseInt(Math.random() * (maxMs - minMs) + minMs);
  return new Promise((resolve) => setTimeout(resolve, durationMs));
};

export const base64ToBlob = ({ imageString, mimeType = 'image/jpeg' }) => {
  const byteCharacters = window.atob(imageString);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });
  return blob;
};

export const cmToInches = (cm) => {
  if (!cm) return cm;
  return Number(cm) / CM_IN_ONE_INCHES;
};
export const inchesToMeters = (inches) => inches * 0.0254;
export const metersToinches = (meters) => meters / 0.0254;
export const feetToMeters = (feet) => feet * 0.3048;
export const metersToFeet = (meters) => meters / 0.3048;
export const cmToMeters = (cm) => cm / 100;
export const metersToCm = (meters) => meters * 100;
export const metersToMeters = (meters) => meters;
export const convertToMeters = (value, unitsName) => {
  const map = {
    cm: cmToMeters,
    feet: feetToMeters,
    inches: inchesToMeters,
    meter: metersToMeters,
  };

  const u = unitsName.toLowerCase();
  return map[u](value);
};

export const inchesToFeet = (inches) => inches / 12;
export const inchesToCentimeter = (inches) => {
  let convertTONumber = Number(inches);
  if (convertTONumber === 0 || isNaN(convertTONumber)) {
    return 0;
  }
  return inches * CM_IN_ONE_INCHES;
};

export const convertMetersToUnits = (value, unitsName) => {
  const map = {
    cm: metersToCm,
    feet: metersToFeet,
    inches: metersToinches,
    meter: metersToMeters,
  };

  const u = unitsName.toLowerCase();
  return map[u](value);
};

export const changeFilter = (filters, field, selection) => {
  let index = _.findIndex(filters, (filter) => {
    return filter.label === field;
  });
  let changeItem = index > 0 ? Object.assign({}, filters[index]) : {};
  changeItem.label = field;
  changeItem.value = selection;
  let newList = Object.assign([], filters);
  if (index >= 0) {
    newList[index] = changeItem;
  } else {
    newList.push(changeItem);
  }
  return newList;
};

export const keyFromLocationState = (location, key) => {
  return location && location.state && location.state[key];
};

export const findCommonElements = (arr1, arr2) => {
  return arr1.filter((i1) => arr2.some((i2) => i1.id === i2.id));
};

export const createUniqueArray = (arr1, arr2 = []) => {
  return [...new Set([...arr1, ...arr2])];
};

export const calcTextureAspectRatio = (width, height) => {
  let nWidth = 1;
  let nHeight = 1;

  if (width > height) nHeight = (height / width).toFixed(2);
  if (height > width) nWidth = (width / height).toFixed(2);

  return [nWidth, nHeight];
};

export const roundToTwo = (num) => {
  return +(Math.round(num + 'e+2') + 'e-2');
};

export const isTransparentImage = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== 'string') return false;

  const url = new URL(imageUrl);
  return url.pathname.endsWith('.png');
};

export const getImageDetails = (src) => {
  let isBlob = src instanceof Blob;
  if (isBlob) {
    src = URL.createObjectURL(src);
  }

  return new Promise((resolve, reject) => {
    const dpi = DEFAULT_DPI; //Static dpi for now, need to find a method to get dpi form image uploaded
    const img = new Image();
    img.onload = () => {
      if (isBlob) URL.revokeObjectURL(src);

      resolve({
        width: img.width,
        height: img.height,
        dpi: dpi,
        widthInches: img.width / dpi,
        heightInches: img.height / dpi,
        widthInCentimeter: toUnityFixed(img.width / dpi) * CM_IN_ONE_INCHES,
        heightInCentimeter: toUnityFixed(img.height / dpi) * CM_IN_ONE_INCHES,
      });
    };
    img.onerror = (error, source) => {
      console.error(error, source);
      if (isBlob) URL.revokeObjectURL(src);
      reject(error);
    };

    img.src = src;
  });
};

export const loadImage = ({ src }) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = src;
  });
};

export const getPerPageCount = () => {
  const height = window.innerHeight;
  const width = window.innerWidth;
  const count = (width / 300) * (height / 300);
  const finalCount = count > 20 ? count : 20;
  return Math.round(finalCount);
};

export const generateUUID = () => {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = ((dt + Math.random() * 16) % 16) | 0;
    dt = Math.floor(dt / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const validateDate = (date) => {
  if (date === null) return false;

  let d1 = new Date(date);
  let d2 = new Date();

  return d1 > d2;
};

export const checkImageTypes = (images, types, errorMsg) => {
  if (images.some((item) => !types.includes(item.type))) {
    apiErrorHandler({ message: errorMsg });
    return false;
  }
  return true;
};

export const getRenderStatusToHighlight = (status) => {
  let res = '';
  switch (status) {
    case RENDER_STATUS.STATUS_FAILED:
      res = 'error';
      break;
    case RENDER_STATUS.STATUS_DONE:
      res = 'success';
      break;

    default:
  }
  return res;
};

export const checkFileSize = (fileSize, requiredSize) => {
  return (fileSize || 0) / (1024 * 1024) <= requiredSize;
};

export const scaleResolution = ({ x, y, max }) => {
  if (x > y) {
    if (x > max) {
      const delta = x / max;
      return { x: max, y: y / delta };
    }
  } else {
    if (y > max) {
      const delta = y / max;
      return { x: x / delta, y: max };
    }
  }

  return { x, y };
};

export const getSortedDataByKey = (source, key) => {
  if (!source.length) return;
  if (!key) return;

  return source.sort((a, b) => {
    // converting to uppercase to have case-insensitive comparison
    const name1 = a[key].toUpperCase();
    const name2 = b[key].toUpperCase();

    let comparison = 0;

    if (name1 > name2) {
      comparison = 1;
    } else if (name1 < name2) {
      comparison = -1;
    }
    return comparison;
  });
};

export const getBrandName = (orgDetails) => {
  const brandName = orgDetails?.name;
  return brandName && NO_BRAND_TAG_ORG.includes(brandName) ? null : brandName;
};

export const getDraggableStyle = (style, snapshot) => {
  // use it when you want to prevent reordering inside of draggable https://github.com/atlassian/react-beautiful-dnd/issues/374
  if (!snapshot.isDragging) return {};
  if (!snapshot.isDropAnimating) {
    return style;
  }

  return {
    ...style,
    // cannot be 0, but make it super tiny
    transitionDuration: `0.001s`,
  };
};

export const reorderDraggableItems = ({
  items,
  draggableId,
  destination,
  tiny,
  nestedOrderKey,
  orderKey = 'order',
}) => {
  const destinationItem = items[destination.index];
  const sourceItem = items.find((item) => item.id == draggableId);
  const destinationOrder = nestedOrderKey
    ? destinationItem[nestedOrderKey][orderKey]
    : destinationItem[orderKey];
  const sourceOrder = nestedOrderKey ? sourceItem[nestedOrderKey][orderKey] : sourceItem[orderKey];
  const min = Math.min(destinationOrder, sourceOrder);
  const max = Math.max(destinationOrder, sourceOrder);
  const reorderedBefore = destinationOrder < sourceOrder;
  let reorderedList = items.map((item) => {
    const itemOrder = nestedOrderKey ? item[nestedOrderKey][orderKey] : item[orderKey];
    if (itemOrder < min || itemOrder > max) return item;
    const obj = JSON.parse(JSON.stringify(item));
    if (nestedOrderKey) {
      obj[nestedOrderKey][orderKey] = destinationOrder;
    } else {
      obj[orderKey] = destinationOrder;
    }
    if (item.id == draggableId) return obj;
    if (reorderedBefore) {
      const obj = JSON.parse(JSON.stringify(item));
      if (nestedOrderKey) {
        obj[nestedOrderKey][orderKey] = itemOrder + 1;
      } else {
        obj[orderKey] = itemOrder + 1;
      }
      return obj;
    } else {
      const obj = JSON.parse(JSON.stringify(item));
      if (nestedOrderKey) {
        obj[nestedOrderKey][orderKey] = itemOrder - 1;
      } else {
        obj[orderKey] = itemOrder - 1;
      }
      return obj;
    }
  });
  const seenOrders = new Set();
  reorderedList = reorderedList.map((item) => {
    const obj = JSON.parse(JSON.stringify(item));
    const getOrder = nestedOrderKey ? obj[nestedOrderKey][orderKey] : obj[orderKey];
    let currentOrder = getOrder;
    while (seenOrders.has(currentOrder)) {
      currentOrder += 1;
    }
    if (nestedOrderKey) {
      obj[nestedOrderKey][orderKey] = currentOrder;
    } else {
      obj[orderKey] = currentOrder;
    }
    seenOrders.add(currentOrder);
    return obj;
  });
  if (tiny) {
    reorderedList = reorderedList.map((item) => {
      const obj = { id: item.id };
      if (nestedOrderKey) {
        obj[nestedOrderKey] = { ...item[nestedOrderKey] };
        obj[nestedOrderKey][orderKey] = item[nestedOrderKey][orderKey];
      } else {
        obj[orderKey] = item[orderKey];
      }
      return obj;
    });
  }
  return reorderedList;
};

export const generateNewName = ({ items, baseName, nameKey = 'name' }) => {
  const isUniqueName = (name) => {
    return !items.find((item) => item[nameKey]?.toLowerCase() === name?.toLowerCase());
  };

  let name = baseName;
  let counter = 1;
  while (!isUniqueName(name)) {
    name = `${baseName} ${counter}`;
    counter++;
  }

  return name;
};

export const sendDataToSubDomain = (pathname, currentUser) => {
  return new Promise((resolve) => {
    // send message to https://imagine.io/ domain
    const postCrossDomainMessage = (data) => {
      // const win = document.getElementById('website-iframe')?.contentWindow;
      // win?.postMessage(data, 'https://imagine.io/user-update-test');

      const frames = document.querySelectorAll('.website-iframe');

      if (frames.length > 0) {
        frames.forEach((frame) => {
          const win = frame?.contentWindow;
          win?.postMessage(data, frame.src);
        });
        resolve(); // Resolve the promise after sending messages
      } else resolve();
    };
    const clearStorage = pathname === LOGIN_HOME || pathname === SIGNUP_ROUTE;
    let localStorageData = JSON.parse(JSON.stringify(localStorage));
    if (currentUser && !localStorageData.current_user) {
      localStorageData.current_user = JSON.stringify(currentUser);
    }
    postCrossDomainMessage({
      sendDataToCrossDomain: true,
      clearStorage: clearStorage,
      localStorageData: localStorageData,
    });
  });
};

export const youtubeParser = (url) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
};

export const getExtensionFromURL = (str) => {
  if (!str) return null;
  const result = str.match(/(\.[0-9a-z]+)(?=\?|#|$)/i);
  return result?.[0] || null;
};

export const removeExtension = (f) => {
  if (!f) return f;
  const dotLastIndex = f.lastIndexOf('.');
  return f.substring(0, dotLastIndex);
};

export const removeSpecialCharacters = (name) => {
  if (!name) return name;
  return name.replace(/\.[^/.]+$/, '').replaceAll(NAME_EXCLUDED_SPECIAL_CHARS_GLOBAL, '_');
};

export const getFirstNameAndLastName = (value, makeNameCapitalize = false) => {
  if (value) {
    const nameArray = value?.split(' ');
    let firstName = nameArray?.[0] || '';
    let lastName = nameArray?.slice?.(1).join?.(' ') || '';

    if (makeNameCapitalize) {
      firstName = firstName?.charAt(0)?.toUpperCase() + firstName?.slice(1);
      lastName = lastName?.charAt(0)?.toUpperCase() + lastName?.slice(1);
    }

    return { firstName, lastName };
  }
  return { firstName: '', lastName: '' };
};

// this function used for download image from URL
/** The last path segment of a URL, without its query string. */
const getUrlFilename = (url) => url?.split('?')?.[0]?.split('/')?.pop() || '';

/** The extension on a URL, or '' when it has none - a `blob:` URL never does. */
export const getUrlExtension = (url) => {
  const parts = getUrlFilename(url).split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
};

/** True when the render itself is filmic rather than standard. */
export const isFilmicRender = (image) =>
  image?.render_image_details?.img_type === RENDER_IMAGE_TYPE.FILMIC;

/**
 * The render as it was produced - filmic file for a filmic render, standard
 * file otherwise. This is the "Original", the base the editor works on and the
 * base the Post Edit preview is built from, so all three stay in step. Render
 * Details and UploadRenderModal already resolve it this way; reading `file`
 * unconditionally hands back the standard image for a filmic render, which is
 * what made Original and Post Edit look swapped on Product Page V1.
 */
export const getRenderOriginalFile = (image) => {
  const details = image?.render_image_details;
  if (!details) return null;
  return isFilmicRender(image) ? details.filmic_file || details.file : details.file;
};

/** The opposite pass, which the editor's Filmic Mode slider blends in. */
export const getRenderOtherFile = (image) => {
  const details = image?.render_image_details;
  if (!details) return null;
  return isFilmicRender(image) ? details.file || details.filmic_file : details.filmic_file || details.file;
};

/**
 * Downloads `url` as `name`.
 *
 * An edited image is handed over as a `blob:` URL, which carries neither a
 * filename nor an extension - hence `extension`, so the caller can name the
 * file after the source it was derived from. Failing that the URL is asked,
 * and failing that the blob's own MIME type.
 */
export const handleDownloadImage = async ({ url, name = null, extension = null } = {}) => {
  if (!url) return;

  const image = await fetch(url);
  const imageBlog = await image.blob();

  const subtype = imageBlog?.type?.split('/')?.[1];
  const ext =
    extension?.replace(/^\./, '')?.toLowerCase() ||
    getUrlExtension(url) ||
    (subtype === 'jpeg' ? 'jpg' : subtype || '');

  const _name = name ? [name, ext].filter(Boolean).join('.') : getUrlFilename(url);
  fileDownload(imageBlog, _name, imageBlog?.type);
};

// sort array data
export const SortArrayBySeq = (value, key) => {
  if (value && value?.length) {
    const data = value.sort((a, b) => +a[key] - +b[key]) || [];
    return data;
  } else {
    return [];
  }
};

// any type of file url to file object conversion
export const urltoFile = (url, filename, mimeType) => {
  if (url.startsWith('data:')) {
    var arr = url.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var file = new File([u8arr], filename, { type: mime || mimeType });
    return Promise.resolve(file);
  }
  return fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], filename, { type: mimeType }));
};
// toggle fullscreen code
export const handleToggleScreen = (elem = document.documentElement, setFullScreen = null) => {
  if (document?.fullscreenEnabled) {
    if (!window?.document?.fullscreen || window.fullscreen) {
      if (elem?.requestFullscreen) {
        elem?.requestFullscreen?.();
      } else if (elem?.webkitRequestFullscreen) {
        /* Safari */
        elem?.webkitRequestFullscreen?.();
      } else if (elem?.msRequestFullscreen) {
        /* IE11 */
        elem?.msRequestFullscreen?.();
      }
      if (setFullScreen) setFullScreen(true);
    } else {
      if (document?.exitFullscreen) {
        document?.exitFullscreen?.();
      } else if (document?.webkitExitFullscreen) {
        /* Safari */
        document?.webkitExitFullscreen?.();
      } else if (document?.msExitFullscreen) {
        /* IE11 */
        document?.msExitFullscreen?.();
      }
      if (setFullScreen) setFullScreen(false);
    }
  } else {
    errorToastV2('Fullscreen is not supported in this browser.');
    console.error('Fullscreen API is not supported in this browser.');
  }
};
// create form data from array using key and value pair
export const getFormData = (array) => {
  const formData = new FormData();
  for (const index in array) {
    Object.keys(array[index]).forEach((key) => formData.append(key, array[index][key]));
  }
  return formData;
};

export const RemoveAllWhiteSpaceFromString = (value) => {
  const whitespaceRemoved = value?.replace(/\s/g, '');
  return whitespaceRemoved || '';
};

export const hubspotHelpChatModuleIconAvailable = () => {
  const iframeElement = document.getElementById('hubspot-conversations-iframe');
  const mainDivElement = document.getElementById('hubspot-messages-iframe-container');

  const hasHideClass = mainDivElement?.classList?.contains('hide-frame');
  const availableFlag = hasHideClass ? false : mainDivElement || iframeElement ? true : false;
  return availableFlag;
};

export const handleScrollPage = () => {
  if (window.$scrollPosition) {
    window?.scrollTo({ top: window.$scrollPosition });
    window.$scrollPosition = null;
  }
};

export const handleClearWindowState = () => {
  window.$scrollPosition = null;
  window.$restrictFilter = null;
  window.$previousURL = null;
};

export const handleScrollToTop = (timeout = 0, position = 0) => {
  // Position is for scroll to position
  // Timeout is second to run this code it's need to provide into milisecond.
  setTimeout(() => {
    window?.scrollTo({ top: position || 0 });
  }, timeout || 0);
};

export const extractDomainFromEmail = (email) => {
  const parts = email.split('@');
  if (parts.length === 2) {
    const domainParts = parts[1].split('.');
    return domainParts?.[0]; // Get the first part of the domain
  } else {
    return null;
  }
};

export const RESTRICT_PERSONAL_EMAIL_FROM_REGISTER = !localStorage.getItem(
  'RESTRICT_PERSONAL_EMAIL_FROM_REGISTER'
)
  ? true
  : localStorage.getItem('RESTRICT_PERSONAL_EMAIL_FROM_REGISTER') === 'true'
    ? true
    : false;

export const phoneRegExp = /^(?:\+\d{1,4}\s?)?\d{1,15}$/;
export const emailRegExp = RESTRICT_PERSONAL_EMAIL_FROM_REGISTER
  ? /^(?!.*@(?:gmail\.com|yahoo\.com|outlook\.com|live\.com|hotmail\.com|gmail\.io|yahoo\.io|outlook\.io|live\.io|hotmail\.io|gmail\.in|yahoo\.in|outlook\.in|live\.in|hotmail\.in|gmail\.org|yahoo\.org|outlook\.org|live\.org|hotmail\.org|test\.com|test\.in|test\.co.in|testing\.com|testing\.in|testing\.co.in)).*$/i
  : /^(?!.*@(?:yahoo\.com|outlook\.com|live\.com|hotmail\.com|gmail\.io|yahoo\.io|outlook\.io|live\.io|hotmail\.io|gmail\.in|yahoo\.in|outlook\.in|live\.in|hotmail\.in|gmail\.org|yahoo\.org|outlook\.org|live\.org|hotmail\.org|test\.com|test\.in|test\.co.in|testing\.com|testing\.in|testing\.co.in)).*$/i;

export const emailIsValidWithExtension = (email) => emailRegExp.test(email);

export const phoneRegexV2 =
  /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{2,4}\)?[-.\s]?)?\d{3,5}[-.\s]?\d{4,6}$/;
export const validatePhoneNumber = (phoneNumber) => phoneRegexV2.test(phoneNumber);

export const getUserTimezone = () => Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || null;

export const getUniqueId = () => window.crypto?.randomUUID()?.replace(/-/g, '');

export const getUserIPAddress = async () => {
  let ipAddress = null;
  await axios
    .get('https://api.ipify.org?format=json')
    .then((response) => {
      ipAddress = response.data.ip;
      return ipAddress;
    })
    .catch((error) => {
      console.log('error', error);
      ipAddress = null;
      return ipAddress;
    });
  return ipAddress;
};

export const removeUndefinedText = (value) => {
  if (value === 'undefined' || value === undefined || value === null || value === 'null') {
    return '';
  } else {
    return value?.replace('undefined', '');
  }
};

export const removeDuplicateEntry = (arr) => {
  const uniqueIds = {};
  return arr?.filter((obj) => {
    if (!uniqueIds[obj?.id]) {
      uniqueIds[obj?.id] = true;
      return true;
    }
    return false;
  });
};
export const totalItemCount = (total) => {
  if (total) {
    return `${total} item${total > 1 ? 's' : ''}`;
  } else {
    return '';
  }
};

export const arrayHaveSameValue = (firstArray, secondArray) => {
  const a = firstArray.sort();
  const b = secondArray.sort();
  const isEqual = a.every((value, index) => +value === +b[index]);
  return isEqual;
};

export const getDownloadAndCollect3DFileAction = ({
  actions = {},
  data = null,
  rest = {},
  designV2 = false,
  download3DFilesZip,
  requestTo3DFilesCollection,
  onUpdate,
}) => {
  const _actions = { ...actions };
  let { zip_file_details } = data || {};
  const qData = getAndSetCookieData({
    cookieName: `${THREE_D_FILE_DOWNLOADS[rest?.itemModelType]}_${
      rest?.itemModelType === MODEL_TYPES.PROJECTRENDER ? data?.main_render : data?.id
    }`,
  });

  if (qData) {
    zip_file_details = qData;
  }

  if (!data) return _actions;

  if (
    zip_file_details &&
    zip_file_details?.status === RENDER_STATUS.STATUS_DONE &&
    zip_file_details?.zip_file
  ) {
    _actions[ACTION.DOWNLOAD_3D_FILES] = {
      label: 'Download 3D Files',
      icon: designV2 ? CollectFilesIcon : <CollectFilesIcon />,
      onClick: () => download3DFilesZip?.(data),
    };
  } else {
    const _actionDisabled =
      zip_file_details &&
      (zip_file_details?.status === RENDER_STATUS.STATUS_NOT_DONE ||
        zip_file_details?.status === RENDER_STATUS.STATUS_PROCESSING) &&
      !zip_file_details?.zip_file;

    _actions[ACTION.COLLECT_3D_FILES] = {
      tooltip:
        zip_file_details?.status === RENDER_STATUS.STATUS_NOT_DONE && !zip_file_details?.zip_file
          ? '3D files collection in process.'
          : '',
      disabled: _actionDisabled,
      label: _actionDisabled ? 'Collecting Data' : 'Collect 3D Files',
      icon: designV2 ? CollectFilesIcon : <CollectFilesIcon />,
      onClick: () => requestTo3DFilesCollection?.({ data, rest, onUpdate }),
    };
  }

  if (rest?.itemModelType === MODEL_TYPES.PROJECTRENDER) {
    _actions[ACTION.UPDATE_JSON_DATA] = {
      label: 'Update Json data',
      icon: designV2 ? FileUploadIcon : <FileUploadIcon />,
      onClick: () => dispatcher(setUpdateJsonModalData(data)),
    };
  }

  return _actions;
};

const stripTrailingSlash = (path) => path.trim().replace(/\/+$/, '');

/*
  Does the current page sort by relevance while searching? The old version tried to
  match `:id` routes by rebuilding the pathname and comparing it to itself, which
  matched every path ending in a number - or a slash, since `+'' === 0` is not NaN -
  so routes that were never listed here dropped their sort too. This compares
  segment by segment instead, and treats a `:param` as a wildcard.
*/
export const removeSortParam = () => {
  const pathSegments = stripTrailingSlash(window?.location?.pathname || '').split('/');

  return REMOVE_SORT_PARAM_ROUTES.some((route) => {
    const routeSegments = stripTrailingSlash(route).split('/');
    if (routeSegments.length !== pathSegments.length) return false;

    return routeSegments.every((segment, index) =>
      segment.startsWith(':') ? Boolean(pathSegments[index]) : segment === pathSegments[index]
    );
  });
};

export const isHubspotDebuggingEnabled = () =>
  sessionStorage.getItem(LF_DEBUGGER_HUBSPOT) === 'true';

const enableDisabledButton = ({ value = '', button = null, email = null }) => {
  if (!button || !email) return;

  const debugMessage = `<ul style="padding: 6px 2px" class="no-list hs-error-msgs inputs-list" role="alert"><li><label class="hs-error-msg hs-main-font-element">You are an internal user. To submit your email, please enable debugging mode by clicking <a href="${
    window.location.origin + window.location.pathname
  }?${LF_DEBUGGER}=1">here</a>.</label></li></ul>`;

  const isExists = value && RESTRICTED_EMAILS.some((a) => value?.includes(a));
  if (!isHubspotDebuggingEnabled() && isExists) {
    button.disabled = true;
    button.style.opacity = 0.5;
    button.style.cursor = 'not-allowed';
    if (email) {
      email.focus();
      email?.nextElementSibling?.remove();
      email.insertAdjacentHTML('afterend', debugMessage);
    }
  } else {
    button.disabled = false;
    button.style.opacity = 1;
    button.style.cursor = 'pointer';
    email?.nextElementSibling?.remove();
  }
};

export const preventFormSubmissionForInternalUsers = ({
  formTitle = '',
  loggedInUserName = '',
  loggedInUserEmail = '',
}) => {
  const iframes = document.querySelectorAll('.hs-form-iframe');
  iframes.forEach((iframe) => {
    const forms = iframe?.contentWindow?.document?.body?.querySelectorAll('form');
    forms.forEach((form) => {
      const dataFormId = form.getAttribute('data-form-id');
      if (form.id === `hsForm_${dataFormId}`) {
        const name =
          form.querySelector(`#name-${dataFormId}`) ||
          form.querySelector(`#full_name-${dataFormId}`);
        const email = form.querySelector(`#email-${dataFormId}`);
        const button = form.querySelector("input[type='submit']");

        if (loggedInUserName && name && !name.value) {
          name.value = loggedInUserName;
          name.readOnly = formTitle === 'Support' && !isHubspotDebuggingEnabled();
          name.focus();
        }
        if (loggedInUserEmail && email && !email.value) {
          email.value = loggedInUserEmail;
          email.readOnly = formTitle === 'Support' && !isHubspotDebuggingEnabled();
          email.focus();
        }

        enableDisabledButton({
          value: email?.value,
          button,
          email,
        });

        email.addEventListener(
          'input',
          (e) => {
            const value = e.target.value;
            enableDisabledButton({
              value,
              button,
              email,
            });
          },
          true
        );
      }
    });
  });
};

export const navigateToNewRequest = ({
  purchase_id = null,
  seq = null,
  is_existing_model = null,
}) => {
  const path = new URL(NEW_REQUEST_ROUTE, window.location.origin);
  if (purchase_id) path.searchParams.set('purchase_id', purchase_id);
  if (seq) path.searchParams.set('seq', seq);
  if (is_existing_model !== null) path.searchParams.set('is_existing_model', is_existing_model);
  window.open(path.href, '_blank');
};

export const removeNumberFromEnd = (str) => {
  if (str) {
    const regex = /\d+/g;
    // Replace the number with an empty string if it matches
    return str.replace(regex, '')?.trim();
  }
  return null;
};
export const getCurrentlyOpenProjectId = (urls, id) => {
  if (!urls?.length) return false;
  const pattern = /\/(\d+)\??/;
  return urls?.some((url) => url?.match(pattern)?.find((value) => +value === +id));
};

export function removeDuplicateParams(url) {
  if (url) {
    const urlObject = new URL(url);
    const params = new URLSearchParams(urlObject.search);
    const uniqueParams = {};

    params.forEach((value, key) => {
      if (!(key in uniqueParams)) {
        uniqueParams[key] = value;
      }
    });
    const newParams = new URLSearchParams(uniqueParams);
    const newUrl = `${urlObject.origin}${urlObject.pathname}?${newParams.toString()}`;
    if (url !== newUrl) window.history.replaceState({ path: newUrl }, '', newUrl);
  }
}

function readAsArrayBuffer(file) {
  return new Response(file).arrayBuffer();
}

export function compare(file1, file2) {
  if (file1.size !== file2.size) return Promise.resolve(false);
  if (file1.name !== file2.name) return Promise.resolve(false);
  return Promise.all([readAsArrayBuffer(file1), readAsArrayBuffer(file2)]).then(([buf1, buf2]) => {
    const arr1 = new Uint8Array(buf1);
    const arr2 = new Uint8Array(buf2);
    return !arr1.some(
      (val, i) => arr2[i] !== val // search for diffs
    );
  });
}

export const progressSliderType = (key) => {
  if (+key <= 30) {
    return PROGRESS_BAR_TYPES.SUCCESS;
  }
  if (+key >= 31 && +key <= 50) {
    return PROGRESS_BAR_TYPES.WARNING;
  }
  if (+key >= 51 && +key <= 80) {
    return PROGRESS_BAR_TYPES.HARD_WARNING;
  }
  if (+key >= 81) {
    return PROGRESS_BAR_TYPES.DANGER;
  }
  return PROGRESS_BAR_TYPES.SUCCESS;
};
export const getPercentValueFromCount = (total, usedItem) => {
  if (total.toString() && usedItem?.toString()) {
    return ((+usedItem / +total) * 100).toFixed();
  } else {
    return 0;
  }
};

export const get3DModelProductJobStatus = (status = null) => {
  if (status === null || status === undefined || status === STATUS_DONE_KEY) return false; // return false for the existing model or that are uploaded manually or without purchase

  // commented "case STATUS_DISABLED_KEY" to show the "In Progress" tag if the status is "STATUS_DISABLED_KEY"
  // we did this as when we upload the model from the Google Drive then we send the "STATUS_DISABLED_KEY" status

  switch (+status) {
    case STATUS_NOT_DONE_KEY:
    case STATUS_PROCESSING_KEY:
    case STATUS_BLENDER_PROCESSING_KEY:
    case STATUS_DISABLED_KEY:
      return 'In Progress';
    case STATUS_FAILED_KEY:
      return 'Failed';
    // case STATUS_DISABLED_KEY:
    //   return 'Scanning File';
    case STATUS_INFECTED_KEY:
      return 'Infected File';
    default:
      return '';
  }
};

/**
 * Determines the status of a 3D model product and textures based on the job send for AR, 360 & Product images.
 * For old cases, i'm using old key
 */
export const get3DModelProductAndTextureStatus = ({
  data = null,
  key = 'product_job_status',
} = {}) => {
  const {
    has_content,
    generate_ar_content_status,
    generate_360_content_status,
    generate_images_content_status,
  } = data || {};
  if (!data) return false;

  const status_360 = [STATUS_PROCESSING_KEY, STATUS_FAILED_KEY].includes(
    generate_360_content_status
  )
    ? generate_360_content_status
    : false;
  const status_image = [STATUS_PROCESSING_KEY, STATUS_FAILED_KEY].includes(
    generate_images_content_status
  )
    ? generate_images_content_status
    : false;
  const status_ar = [STATUS_PROCESSING_KEY, STATUS_FAILED_KEY].includes(generate_ar_content_status)
    ? generate_ar_content_status
    : false;

  const status = status_360 || status_image || status_ar;
  if ((status === false || !has_content) && key) return get3DModelProductJobStatus(status?.[key]);

  return 'Generating visuals';
};

export const isIphoneIOS = () => {
  const userAgent = navigator.userAgent;
  let os = false;
  // // for local env
  // if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.indexOf("Safari") > -1) {
  //   os = true;
  // }
  // production env
  if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
    os = true;
  }
  return os;
};

export const getTextSubstring = (text = '', maxLength = 50) => {
  if (text && typeof text === 'string' && text?.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
};

export const getPlanRecurringPeriod = (item) => {
  const index = item?.recurring_interval + '_' + item?.recurring_interval_count;
  return frequency?.[index] || '';
};

export const getThumbnailCardTagList = (product = null, isV2 = false) => {
  if (!product) return [];
  const isPartnerModelUploaded = product?.is_partner_model_uploaded;
  const productJobStatus = isV2
    ? get3DModelProductAndTextureStatus({
        data: product,
      })
    : get3DModelProductJobStatus(product?.product_job_status);
  const requestStatus = product?.request_details?.status;
  const thumbnail =
    !product?.thumbnail && product?.base_model_details?.thumbnail
      ? product?.base_model_details?.thumbnail
      : product?.thumbnail;
  let finalData = [
    productJobStatus && typeof productJobStatus === 'string'
      ? { type: 'pending', label: productJobStatus }
      : null,
    requestStatus === REQUEST_STATUSES.FOR_APPROVAL.value
      ? {
          type: 'pending',
          label: 'Approval is pending',
        }
      : null,
    requestStatus === REQUEST_STATUSES.FEEDBACK.value
      ? {
          type: 'pending',
          label: 'Under feedback',
        }
      : null,
    !thumbnail && product.is_prop_group
      ? { type: 'pending', label: 'Thumbnail in progress' }
      : null,
    product?.is_mattress_texture ? { type: 'pending', label: 'Exclusive for Mattress' } : null,
  ].filter(Boolean);

  if (isPartnerModelUploaded) {
    finalData = finalData.filter(
      (tag) => !tag?.label?.toLowerCase?.().includes('in progress')
    );
  }

  if (
    !finalData?.length &&
    product?.prop_data_user_file &&
    !product?.product_file &&
    !isPartnerModelUploaded
  ) {
    const tags = [{ type: 'pending', label: 'In progress' }];
    if (product?.is_mattress_texture) {
      tags.push({ type: 'pending', label: 'Exclusive for Mattress' });
    }
    return tags;
  }
  return finalData;
};

export const getFirstWord = (str) => {
  return str?.split(' ')[0] || null;
};

export const setOverflowAutoInBody = () => {
  document.body.style.overflow = 'auto';
};

export const isAPIError = (isError) => {
  if (isError !== true && isError !== false) return window.$isError;
  window.$isError = isError;
  return window.$isError;
};

export const generateURLFromBrowser = () => {
  const currentUrl = window.location.href;
  const parsedUrl = new URL(currentUrl);
  const templateId = parsedUrl.searchParams.get('templateId');
  const propsId = parsedUrl.searchParams.get('propId');
  const renderId = parsedUrl.searchParams.get('renderId');
  const cameraName = parsedUrl.searchParams.get('cameraName');
  const selectedPlanId = parsedUrl.searchParams.get('selectedPlanId');
  const selectedPlanPriceId = parsedUrl.searchParams.get('selectedPlanPriceId');
  const selectedInterval = parsedUrl.searchParams.get('selectedInterval');
  const openDashboard = parsedUrl.searchParams.get('openDashboard');
  if (renderId) {
    return !cameraName
      ? `/curator/room/open?renderId=${renderId}`
      : `/curator/room/open?renderId=${renderId}&cameraName=${cameraName}`;
  }
  if (templateId && propsId) {
    return !cameraName
      ? `/curator/room/${templateId}?propId=${propsId}`
      : `/curator/room/${templateId}?propId=${propsId}&cameraName=${cameraName}`;
  }
  if (templateId) {
    return !cameraName
      ? `/curator/room/${templateId}`
      : `/curator/room/${templateId}?cameraName=${cameraName}`;
  }
  if (selectedPlanId && selectedPlanPriceId && selectedInterval) {
    // return `/pricing?selectedPlanId=${selectedPlanId}&selectedPlanPriceId=${selectedPlanPriceId}&selectedInterval=${selectedInterval}`;
    return `/my-plans?selectedPlanId=${selectedPlanId}&selectedPlanPriceId=${selectedPlanPriceId}&selectedInterval=${selectedInterval}`;
  }
  if (openDashboard) {
    return `/dashboard`;
  }
  return null;
};

export const generatePassword = (length = 8) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  window.$recentPassword = password;
  return password;
};

export const addOneMonthAddCurrentYear = (value) => {
  if (!value) {
    return null;
  }
  const date = moment(value);
  return date.format('MMM D, YYYY');
};

export const getFilterLabelOptionId = (list, labelName, optionName) => {
  const matchingItems = list?.find(({ label_name }) => label_name === labelName);
  const id = matchingItems?.options?.find(({ name }) => name === optionName)?.id || null;
  return id;
};
export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  const brightness =
    parseInt(color.slice(1, 3), 16) * 0.299 +
    parseInt(color.slice(3, 5), 16) * 0.587 +
    parseInt(color.slice(5, 7), 16) * 0.114;
  // If the color is too light, call the function again to get a darker color
  return brightness > 200 ? getRandomColor() : color;
};

export const isGmailAccountDomain = (email) => {
  // Check if the email ends with
  const allowedDomains = ['@gmail.com', '@gmail.in', '@googlemail.com', '@gmail.co'];
  // Check if the email ends with any of the allowed domains
  return allowedDomains.some((domain) => email?.toLowerCase()?.endsWith?.(domain));
};

// here, we are creating unique Id to identify user by combining UUID & current timestamp
// if we don't have Id stored then we are creating & storing in localstorage
// if we have then we are getting it from the localstorage & return it
export function getOrGenerateEpochUUID() {
  const existingUUID = localStorage.getItem(USERPILOT_UUID);
  if (existingUUID) return existingUUID;

  const epochTime = Math.floor(Date.now() / 1000); // Get current time in epoch format
  const uuid = window.crypto?.randomUUID()?.replace(/-/g, ''); // Generate a UUID4 and remove hyphens
  const combinedId = uuid ? `${epochTime}${uuid}` : epochTime; // Combine epoch time and UUID
  localStorage.setItem(USERPILOT_UUID, combinedId);

  return combinedId;
}

// when user comes from website in order to register then
// we save uuid in URL in localstorage
// and further use this id to register
export function saveEpochUUID() {
  const uuid = new URLSearchParams(decodeURI(window.location.search)).get('uuid');
  const existingUUID = localStorage.getItem(USERPILOT_UUID);

  if (uuid === existingUUID) return;
  if (uuid) {
    localStorage.setItem(USERPILOT_UUID, uuid);
    const newUrl = window.location.href.replace(`uuid=${uuid}`, '').replace(/[?&]$/, '');
    window.history.replaceState({}, document.title, newUrl);
  }
}

export const getAndSetHideDiscountModalCookieData = (cookieName, data = null) => {
  try {
    if (data !== null) {
      // Serialize and store data as a cookie
      // Set the cookie to expire in 1 day
      const d = new Date();
      d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000); // 1 day
      const expires = 'expires=' + d.toUTCString();
      document.cookie =
        cookieName + encodeURIComponent(JSON.stringify(data)) + ';' + expires + ';path=/';
    }

    // Retrieve and parse the cookie data
    const decodedCookies = decodeURIComponent(document.cookie);
    const ca = decodedCookies.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(cookieName) == 0) {
        return JSON.parse(c.substring(cookieName.length, c.length));
      }
    }
    return null;
  } catch (error) {
    console.error('Error in getAndSetHideDiscountModalCookieData:', error);
    return null;
  }
};

export const isUserComingFromWebsite = () => {
  //  for users who comes from the website via model/texture upload, edit template or example, checking the params value which confirms that the user comes from the website
  const p = new URLSearchParams(window.location.search);
  return p?.get('main_origin') || p?.get('curatorOpenSource');
};

export const createImageThumbnail = ({
  file,
  customWidth = THUMBNAIL_MAX_RESOLUTION,
  customHeight = THUMBNAIL_MAX_RESOLUTION,
}) => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.src = url;

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        let width = customWidth;
        let height = customHeight;
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        aspectRatio > 1 ? (height = width / aspectRatio) : (width = height * aspectRatio);

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Failed to create thumbnail blob'));
            }
          },
          'image/jpeg', // Image format
          0.75 // Image quality
        );
      } catch (error) {
        reject(error);
      }
    };

    img.onerror = (error) => {
      reject(error);
    };
  });
};

export const createVideoThumbnail = ({ file, time = 1.0 }) => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.src = url;

    video.onloadeddata = () => {
      try {
        video.currentTime = time;
      } catch (error) {
        reject(error);
      }
    };

    video.onerror = (error) => {
      reject(error);
    };

    video.onseeked = () => {
      try {
        const canvas = document.createElement('canvas');
        let width = THUMBNAIL_MAX_RESOLUTION;
        let height = THUMBNAIL_MAX_RESOLUTION;
        const aspectRatio = video.videoWidth / video.videoHeight;
        aspectRatio > 1 ? (height = width / aspectRatio) : (width = height * aspectRatio);

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, width, height);

        // region Add play icon
        const iconSize = Math.min(canvas.width, canvas.height) / 6; // Size of the circle and triangle
        const centerX = canvas.width / 2; // Center X
        const centerY = canvas.height / 2; // Center Y

        // Draw the background circle
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)'; // Semi-transparent black
        ctx.beginPath();
        ctx.arc(centerX, centerY, iconSize, 0, Math.PI * 2);
        ctx.fill();

        // Draw the triangle (play icon)
        ctx.fillStyle = 'rgb(238, 238, 238)'; // Triangle color
        const triangleBase = iconSize * 0.75; // Base length of the triangle
        const triangleHeight = iconSize * 0.75; // Height of the triangle

        ctx.beginPath();
        ctx.moveTo(centerX - triangleBase / 3, centerY - triangleHeight / 2); // Top point
        ctx.lineTo(centerX - triangleBase / 3, centerY + triangleHeight / 2); // Bottom-left point
        ctx.lineTo(centerX + triangleBase / 1.75, centerY); // Right point
        ctx.closePath();
        ctx.fill();

        // end region

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Failed to create thumbnail blob'));
            }
          },
          'image/jpeg',
          0.75
        );
      } catch (error) {
        reject(error);
      }
    };

    video.currentTime = time; // Trigger seeking to the specified time
  });
};

export const calculateCuratorTilingForTexture = (value = null) => {
  if (!value) return 1;
  // 12: feet
  return 10 / (parseFloat(value) / (12 * CM_IN_ONE_INCHES));
};

export const createARJob = async (data = null) => {
  if (!data) return;
  const formData = new FormData();
  formData.append('product', data?.id);
  formData.append('status', 0);
  formData.append('generate_ar', true);

  // Removing .skp file support
  // if (getExtensionFromURL(data?.prop_data_user_file) === '.skp') {
  //   // Skp File render
  //   formData.append('is_skp', true);
  // }

  await apiPost3DModelJob(formData);
};

export const createModelAutomationRender = async ({
  data,
  transparentBg = false,
  shadowOnFloor = true,
  preventRedirection = false,
  showMessage = true,
  arJob = true,
  viewerJob = true,
  imageJob = true,
  showMessageBeforeJobSend = false,
  successMessage = 'Your visuals are being generated',
  onlyDimensionRender = false,
  excludeDimensionRender = false,
  isDimensionShot = false,
  selectedListRoomList = [],
  selectedCameraPresets = {},
  restrictDirection = false,
} = {}) => {
  if (showMessageBeforeJobSend && showMessage) successToast(successMessage);

  if (arJob) await createARJob(data);

  if (viewerJob) {
    await sendRenderForAutomation360({ uploadedProductId: data?.id, data });
  }

  if (imageJob) {
    if (selectedListRoomList?.length) {
      await sendRenderForAutomationManualSelectionTemplates({
        uploadedProductId: data?.id,
        data,
        transparentBg,
        shadowOnFloor,
        excludeDimensionRender,
        isDimensionShot,
        selectedListRoomList,
        selectedCameraPresets,
      });
    } else {
      await sendRenderForAutomation({
        uploadedProductId: data?.id,
        data,
        transparentBg,
        shadowOnFloor,
        onlyDimensionRender,
        excludeDimensionRender,
      });
    }
  }

  if (!showMessageBeforeJobSend && showMessage) successToast(successMessage);
  await wait(1000);
  if (!preventRedirection)
    navigate(ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2.replace(':id', data?.id), '_self');

  if (onlyDimensionRender && !restrictDirection) {
    navigate(RENDERS_PREVIEWS_ROUTE_V2);
  }
};

// Trigger the GTM event when user trigger this function
export const googleTagEventPush = (payload = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

const base64ToFile = (base64, fileName, mimeType) => {
  const arr = base64.split(',');
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mimeType });
};

export const reEncodeBase64 = (base64Image) => {
  // Uncomment this if you want to remove the firefox condition
  // Also comment out the below onload function which is working
  // const blob = base64ToBlob({imageString: base64Image.split(",")[1], mimeType: 'image/jpeg'});
  // const imageUrl = URL.createObjectURL(blob);

  // const img = new Image();
  // img.src = imageUrl;
  // img.onerror = (err) => console.error('Error loading image:', err);
  // return new Promise((resolve) => {
  //   img.onload = () => {
  //     document.body.appendChild(img);
  //     URL.revokeObjectURL(imageUrl); // Free memory
  //     const canvas = document.createElement('canvas');
  //     canvas.width = img.width;
  //     canvas.height = img.height;
  //     const ctx = canvas.getContext('2d');
  //     ctx.drawImage(img, 0, 0);
  //     // Re-encode the image to JPEG base64
  //     resolve(canvas.toDataURL('image/jpeg'));
  //   };
  // });
  const img = new Image();
  img.src = base64Image;
  return new Promise((resolve) => {
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      // Re-encode the image to JPEG base64
      resolve(canvas.toDataURL('image/jpeg'));
    };
  });
};

export const removeExifFromImage = (file) => {
  const allowedTypes = ['image/jpeg', 'image/tiff'];
  try {
    if (!file || !file?.type?.startsWith('image/') || !allowedTypes.includes(file.type)) {
      return file;
    }
  } catch (error) {
    return file;
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    // Read the file as a base64 string
    reader.onload = async (event) => {
      try {
        // Added firefox check to as reEncodeBase64 is not working for image > 30mb in firefox
        // so returning original file
        if (file.type === 'image/jpeg' && !navigator.userAgent.search('Firefox')) {
          let base64Image = event.target.result;
          // Remove EXIF metadata from JPEG using piexif
          base64Image = await reEncodeBase64(base64Image);
          const strippedBase64 = piexif.remove(base64Image);
          const cleanedFile = base64ToFile(strippedBase64, file.name, file.type);
          resolve(cleanedFile);
        } else if (file.type === 'image/tiff' && !navigator.userAgent.search('Firefox')) {
          // Remove EXIF metadata from TIFF using ExifTool
          const exifTool = new ExifTool();
          const buffer = await file.arrayBuffer();
          const cleanedBuffer = await exifTool.removeMetadata(buffer);
          const cleanedFile = new File([cleanedBuffer], file.name, { type: file.type });
          resolve(cleanedFile);
        } else {
          // Return the original file if no operation is needed
          resolve(file);
        }
      } catch (error) {
        console.log(error, 'error');
        resolve(file);
      }
    };
    reader.onerror = () => {
      resolve(file);
    };
    reader.readAsDataURL(file); // Convert the file to a base64 string
  });
};

export const removeExifFromMultipleFiles = async (files) => {
  if (!Array.isArray(files)) {
    files = [files];
  }
  const cleanedFiles = await Promise.all(
    files.map(async (file) => {
      const cleanedFile = await removeExifFromImage(file);
      return cleanedFile;
    })
  );
  return Array.from(cleanedFiles);
};

export const isARJob = (data) => data?.AR?.value;
export const isViewerJob = (data) => data?.VIEWER?.value;
export const isImageJob = (data) => data?.IMAGE?.value;

export const regenrateContentDialog = ({
  generateContent,
  openInfoDialog,
  closeInfoDialog,
  isModel,
}) => {
  const _data = {
    VIEWER: {
      title: '360 Viewer',
      value: false,
    },
    IMAGE: {
      title: 'Product Image',
      value: false,
    },
  };
  if (isModel) {
    _data.AR = {
      title: 'AR + 3D Viewer',
      value: false,
    };
  }

  openInfoDialog({
    title: 'Generate Visuals',
    description: `The content for this ${
      isModel ? 'product' : 'texture'
    } is already created. Do you really want to generate the content again? Please select items you wish to regenerate.`,
    buttonText: 'Generate',
    backdrop: 'static',
    okButtonProps: {
      style: { opacity: 0.2, pointerEvents: 'none' },
      id: 'imagine-button-regenerate-backdrop-button',
    },
    onButtonClick: async (e) => {
      const anyComplete = Object.values(_data)?.some((_item) => _item?.value);
      if (anyComplete) await generateContent(_data);
      else warningToast('Please select any item to generate');
    },
    cancelButtonText: 'Cancel',
    onCancelClick: () => closeInfoDialog(),
    children: (
      <div className="d-flex flex-column px-3 gap-2">
        {Object.keys(_data)?.map((_item) => {
          const item = _data[_item];

          return (
            <div className="d-flex align-item-center justify-content-between" key={item}>
              <span
                style={{
                  color: 'var(--neutral80-color)',
                  fontSize: '15px',
                  fontWeight: '500',
                }}>
                {item?.title}
              </span>
              <Switch
                onToggle={() => {
                  item.value = !item.value;
                  const anyComplete = Object.values(_data)?.some((_item) => _item?.value);
                  const element = document.getElementById(
                    'imagine-button-regenerate-backdrop-button'
                  );
                  if (!anyComplete) {
                    element.style.pointerEvents = 'none';
                    element.style.opacity = 0.5;
                  } else {
                    element.style.pointerEvents = 'all';
                    element.style.opacity = 1;
                  }
                }}
              />
            </div>
          );
        })}
      </div>
    ),
  });
};

export const captureSentryException = (_data, otherInfo, file) => {
  const user = JSON.parse(getLocalStorage(CURRENT_USER));
  let data = {
    user_id: user?.id,
    org_id: user?.organization,
    org_name: user?.organization_detail?.name,
    user_email: user?.user?.email,
    user_name: user?.user?.name,
    ..._data,
  };

  // Sentry.withScope((scope) => {
  //   if (file) {
  //     const blob = new Blob(["File content"], { type: "text/plain" });
  //     // const blob = new Blob([file], { type: file.type });
  //     console.log("yoyo", blob)
  //     scope.addAttachment({
  //       filename: file.name,
  //       data: blob,
  //     });
  //   }
  //   Sentry.captureException(data, otherInfo)
  // })

  if (!isPublicPageView()) {
    Sentry.captureException(data, otherInfo);
  }
};

export const sendModelViewerExceptionToSentry = ({ message, file, otherInfo = '' }) => {
  let data = {
    failed_reason: message,
    other_warning_or_information: otherInfo,
    notification_type: SENTRY_ERROR_TYPES.NOTIFICATION,
  };

  if (file) {
    data = {
      ...data,
      file_id: file.id,
      file_name: file.name,
      file_size: `${convertBytesInMB(file?.size)}MB`,
      file_extension: file.name.split('.').at(-1),
    };
  }

  captureSentryException(
    data,
    {
      tags: {
        issue_type: SENTRY_ERROR_TYPES.NOTIFICATION,
      },
    },
    file
  );
};

export async function fetchWithRetry(api, data = {}, retryInterval = 5000) {
  let retryCount = 0;

  // Check network status
  const isOnline = () => navigator.onLine;

  while (true) {
    // try {
    if (!isOnline()) {
      console.log('Network offline. Retrying...');
      await new Promise((resolve) => setTimeout(resolve, retryInterval));
      retryCount++;
      continue;
    }

    // Try fetching the API
    const response = await api(data);
    if (response?.status) {
      console.log('Request successful!');
      return response; // Return the response if successful
    }
    //  catch (error) {
    //   console.error("Error:", error.message);

    //   // Retry after a delay
    //   await new Promise((resolve) => setTimeout(resolve, retryInterval));
    //   retryCount++;

    //   // Optional: Log retry attempts
    //   console.log(`Retry attempt: ${retryCount}`);
    // }
  }
}
export const getDateTimeStampValue = (value = null) => {
  if (value) {
    value = new Date(value)?.getTime();
  }
  return value || null;
};

// This function is needed to show enterprise form in case of freemium user whose org is created after 10th Feb 2025
export const openFormInCaseOfNewOrgAndFreemiumUser = ({
  title = '',
  description = '',
  secondLineDescription = '',
  buttonText = '',
  cancelButtonText = '',
  descriptionStyle = {},
  onCancelClick,
} = {}) => {
  const onClose = () => {
    dispatcher(setEnterpriseFormDialogOpen(false));
    onCancelClick?.();
  };
  openInfoDialog({
    title: title || 'We’d Love to Help!',
    description:
      description ||
      'To access this feature, simply fill out our quick Enterprise Request Form, and our team will reach out to you soon.',
    secondLineDescription,
    descriptionStyle,
    buttonText: buttonText || 'Continue',
    cancelButtonText: cancelButtonText || 'Cancel',
    onButtonClick: () => dispatcher(setEnterpriseFormDialogOpen(true)),
    onCancelClick: onClose,
    onClose: onClose,
  });
};

export const isTextureProductPage = () => {
  const isTexture = window.location.pathname.includes(
    ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2.replace(':id', '')
  );
  const isPublicTexture = window.location.pathname.includes(
    ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2.replace(':id', '')
  );
  return isTexture || isPublicTexture || false;
};

export const getProductPageType = () =>
  isTextureProductPage() ? TEXTURE_CATEGORY : PRODUCT_CATEGORY;

export const removeInvertedCommaFromStartEnd = (str = '') => {
  if (!str) return str;

  if (str?.startsWith('"') && str?.endsWith('"')) {
    return str.slice(1, -1); // Remove the first and last character
  }
  return str;
};

export function canvasToBlob(canvas, type = 'image/png', quality) {
  // Convert the canvas to a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to create blob from canvas'));
        }
      },
      type,
      quality
    );
  });
}

export function RGBToGrayScale(r, g, b) {
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export const getCurrentUserFromLocalStorage = () => {
  const currentUser = JSON.parse(getLocalStorage('current_user')) || null;
  return currentUser;
};

export const addOrgIdIntoAPIUrl = (url) => {
  if (!url) return null;
  const orgId = getCurrentUserFromLocalStorage()?.organization;
  if (!orgId) {
    console.log('org id not available');
    return url;
  }
  const sideFilterSegment = '/sidefilter/';
  const index = url.indexOf(sideFilterSegment);
  if (index === -1) {
    console.error("The URL does not contain the '/sidefilter/' segment.");
    return url;
  }
  const before = url.slice(0, index + sideFilterSegment.length);
  const after = url.slice(index + sideFilterSegment.length);
  return `${before}${orgId}/${after}`;
};

export const updatePositionHubSpotChatIcon = (
  updatePosition = false,
  className = 'update-position-hubSpot-chat-icon-member'
) => {
  const el = document.getElementById('hubspot-messages-iframe-container');
  if (el) {
    if (updatePosition) {
      el?.classList?.add(className);
    } else {
      el?.classList?.remove(className);
    }
  }
};

// Utility function to check if two arrays are equal
export const areArraysEqual = (prevArray, newArray) => {
  // If the lengths are different, the arrays are not equal
  if (prevArray.length !== newArray.length) {
    return false; // Different lengths imply they are not equal
  }
  // Check for deep equality of each item in the arrays
  return prevArray.every((item, index) => {
    return JSON.stringify(item) === JSON.stringify(newArray[index]);
  });
};

export const extractIds = (data = [], key = 'brand_') => {
  return data
    .filter((item) => item.startsWith(key))
    .map((item) => item.replace(key, ''))
    .join(',');
};
// Check base64 image is fully transparent or is black image
export const isImageBlankOrTransparent = (base64, callback) => {
  const img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    let isTransparent = true;
    let isBlack = true;

    for (let i = 0; i < data.length; i += 4) {
      const [r, g, b, a] = [data[i], data[i + 1], data[i + 2], data[i + 3]];

      if (a !== 0) {
        isTransparent = false;
      }

      if (r !== 0 || g !== 0 || b !== 0 || a !== 255) {
        isBlack = false;
      }

      // Early exit if neither
      if (!isTransparent && !isBlack) break;
    }
    return callback(isTransparent || isBlack ? false : true);
  };

  img.onerror = () => {
    console.error('Invalid base64 image');
    return callback(false);
  };
  img.src = base64;
};

export const renameDuplicateNames = (array = [], key = 'name') => {
  const nameCount = {};
  return array.map((item) => {
    const baseName = item[key];
    if (!nameCount[baseName]) {
      nameCount[baseName] = 1;
      return { ...item, [key]: baseName }; // First instance — no change
    } else {
      const newName = `${baseName} (${nameCount[baseName]})`;
      nameCount[baseName]++;
      return { ...item, [key]: newName }; // Apply new name
    }
  });
};

export async function getImage(url) {
  return new Promise((resolve) => {
    const image = new Image();
    // crossOrigin has to be set before src: a copy already sitting in the
    // browser cache from a plain <img> loads without CORS and taints every
    // canvas it is drawn on, which fails the export rather than the load.
    image.crossOrigin = 'anonymous';
    // Resolving null rather than hanging - a render with no filmic pass has no
    // URL to load here, and the caller skips that layer instead of waiting for
    // an onload that never comes.
    image.onerror = () => resolve(null);
    image.onload = () => resolve(image);
    image.src = url;
  });
}

export function deepEqual(obj1, obj2) {
  // Check if both are strictly equal (handles cases like both being null or both the same primitive value)
  if (obj1 === obj2) {
    return true;
  }

  // If either is not an object or is null, they're not equal
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  // Get the keys of both objects
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  // If the number of keys is different, the objects are different
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Compare all keys and values recursively
  for (let key of keys1) {
    // If the key doesn't exist in obj2, objects are different
    if (!keys2.includes(key)) {
      return false;
    }

    // Recursively compare values for each key
    if (!deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export const textLowerCaseAndTrim = (value) => {
  return value?.trim()?.toLowerCase?.();
};

export const isInternalUser = () => {
  const user = localStorage.getItem(CURRENT_USER)
    ? JSON.parse(localStorage.getItem(CURRENT_USER))?.user?.email
    : null;
  const isInternalUser = RESTRICTED_EMAIL_DOMAIN?.some((domain) => user?.includes(domain));
  return isInternalUser;
};

export const clearCacheFromAPI = (enableCacheAfterSec = 0) => {
  const timestamp = Date.now();

  if (enableCacheAfterSec > 0)
    setTimeout(() => dispatcher(setUseCacheInAPI(timestamp)), enableCacheAfterSec);
  else dispatcher(setUseCacheInAPI(timestamp));
  // dispatcher(setUseCacheInAPI(false)); // false - It tells the api to clear the cache by adding this { "Cache-Control": "no-cache" } in the header of the API

  // setTimeout(() => {
  //   dispatcher(setUseCacheInAPI(true)); // true - It enable the flag that do not use the "no-cache" in the header of the API.
  // }, enableCacheAfterSec);
};

// Extract images from pdf
function addAlphaChannelToUnit8ClampedArray(unit8Array, imageWidth, imageHeight) {
  const newImageData = new Uint8ClampedArray(imageWidth * imageHeight * 4);

  for (let j = 0, k = 0, jj = imageWidth * imageHeight * 4; j < jj; ) {
    newImageData[j++] = unit8Array[k++];
    newImageData[j++] = unit8Array[k++];
    newImageData[j++] = unit8Array[k++];
    newImageData[j++] = 255;
  }

  return newImageData;
}

async function getPageImages(pageNum, pdfDocumentInstance) {
  try {
    const pdfPage = await pdfDocumentInstance.getPage(pageNum);

    // Get the viewport for the page
    const viewport = pdfPage.getViewport({ scale: 1.0 }); // Increase Scale for better quality

    // Create canvas to render the full page
    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const ctx = canvas.getContext('2d');

    // Render the PDF page to canvas
    const renderContext = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await pdfPage.render(renderContext).promise;

    // Convert canvas to JPG blob
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          resolve([blob]); // Return as array to maintain compatibility
        },
        'image/jpeg',
        0.95
      ); // JPG format with 95% quality
    });
  } catch (error) {
    console.error(error);
    return [];
  }
}

// async function getPageImages(pageNum, pdfDocumentInstance) {
//   try {
//     const pdfPage = await pdfDocumentInstance.getPage(pageNum);
//     const operatorList = await pdfPage.getOperatorList();

//     const validObjectTypes = [
//       window.pdfjsLib.OPS.paintImageXObject,
//       window.pdfjsLib.OPS.paintImageXObjectRepeat,
//       window.pdfjsLib.OPS.paintJpegXObject,
//     ];

//     // Collect promises for each image
//     const imagePromises = operatorList.fnArray
//       .map((op, idx) => {
//         if (!validObjectTypes.includes(op)) return null;

//         const imageName = operatorList.argsArray[idx][0];

//         return new Promise((resolve) => {
//           pdfPage.objs.get(imageName, (image) => {
//             const imageUint8WithAlpha = addAlphaChannelToUnit8ClampedArray(
//               image.data,
//               image.width,
//               image.height
//             );

//             const imageData = new ImageData(imageUint8WithAlpha, image.width, image.height);

//             const canvas = document.createElement('canvas');
//             canvas.width = image.width;
//             canvas.height = image.height;

//             const ctx = canvas.getContext('2d');
//             ctx.putImageData(imageData, 0, 0);

//             canvas.toBlob((blob) => {
//               resolve(blob);
//             }, 'image/png');
//           });
//         });
//       })
//       .filter(Boolean); // remove nulls

//     return await Promise.all(imagePromises);
//   } catch (error) {
//     console.error(error);
//     return [];
//   }
// }

const onLoadFile = async (event) => {
  // return new Promise((resolve, reject) => {
  try {
    // turn array buffer into typed array
    const typedArray = new Uint8Array(event.target.result);

    const loadingPdfDocument = window.pdfjsLib.getDocument(typedArray);
    const pdfDocumentInstance = await loadingPdfDocument.promise;

    const totalNumPages = pdfDocumentInstance.numPages;
    const pagesPromises = [];

    for (let currentPage = 1; currentPage <= totalNumPages; currentPage += 1) {
      pagesPromises.push(getPageImages(currentPage, pdfDocumentInstance));
    }

    const pagesData = await Promise.all(pagesPromises);
    const allImages = pagesData?.reduce((a, c) => {
      a.push(...c);
      return a;
    }, []);

    // resolve(allImages);
    return allImages;
  } catch (error) {
    //     console.log(error);
    //     reject(error)

    return null;
  }
  // })
};

export function getImagesFromPdf(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = async (e) => {
      try {
        const images = await onLoadFile(e);
        resolve(
          images?.map((image, index) => {
            image.name = `${file?.name?.split('.')?.[0] || ''}_image_${index}.png`;
            return image;
          })
        );
      } catch (err) {
        reject(err);
      }
    };

    fileReader.onerror = reject;
    fileReader.readAsArrayBuffer(file);
  });
}

export const formatNumber = (value) => {
  const rounded = Math.round(+value * 100) / 100; // round to 2 decimals
  return Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2);
};

export function getHdriRotationForOldProjects(hdriRotation) {
  let oldHDRIRotation = parseInt(hdriRotation) - 90;

  if (oldHDRIRotation < 0) oldHDRIRotation += 360;

  return { x: 0, y: oldHDRIRotation, z: 0 };
}

export function compareSelected(
  current,
  initial,
  keys = [
    'material.x',
    'material.y',
    'material.width',
    'material.height',
    'material.rotation',
    'glossiness.intensity',
    'metallic.intensity',
    'texture.rotation',
  ]
) {
  for (const key of keys) {
    const valueA = key.split('.').reduce((o, p) => o?.[p], current);
    const valueB = key.split('.').reduce((o, p) => o?.[p], initial);

    if (valueA !== valueB) {
      return { changed: true, key, valueA, valueB };
    }
  }

  return { changed: false };
}

// Creates a hidden iframe to ensure Frappe session logout even if the main iframe isn't loaded
export const createFrappeFrameAndLogout = () => {
  try {
    const frappeOrigin = process.env.REACT_APP_FRAPPE_APP_URL;
    const isLogoutTrigged = getLocalStorage('FRAPPE_APP_LOGOUT');

    // If we don't have origin cached, skip creating iframe
    if (!frappeOrigin || !isLogoutTrigged) return;

    const iframe = document.createElement('iframe');
    // Prefer explicit logout path when possible
    const logoutUrl = `${frappeOrigin}/helpdesk/logout`;
    iframe.src = logoutUrl;
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    iframe.onload = () => {
      // Clear cached frappe keys once logout is attempted
      removeLocalStorage('FRAPPE_APP_URL');
      removeLocalStorage('FRAPPE_FETCHED_ORG');
      removeLocalStorage('FRAPPE_APP_READY');
      removeLocalStorage('FRAPPE_APP_LOGOUT');

      setTimeout(() => {
        iframe.remove();
      }, 1500);
    };

    document.body.appendChild(iframe);
  } catch (err) {
    // no-op
  }
};

export const makeDummyEntry = (count = 6) => {
  return Array.from({ length: count }, (_, index) => ({
    id: index + 1,
    render_image_details: {
      status: 0,
    },
    product: 1,
    seq_no: index + 1,
    category: 4,
    combineId: `${index + 1}_4`,
  }));
};

// Constants
export const MAX_ALLOWED_DOMAINS = 5;

/**
 * Validate domain string format.
 *
 * Supported formats:
 * 1. Standard domains: example.com, subdomain.example.com, api.v2.example.com
 * 2. Wildcard subdomains: *.example.com — matches any subdomain of example.com
 * 3. Localhost: localhost, localhost:8000, 127.0.0.1, 127.0.0.1:8000
 * 4. IP addresses with ports: 192.168.1.1:3000
 * 5. Domains with ports: example.com:3000, app.example.com:8080
 */
export const isValidDomain = (domain) => {
  if (!domain || typeof domain !== 'string') return false;

  // Trim whitespace
  let domainClean = domain.trim();
  if (!domainClean) return false;

  // Strip protocol (http:// or https://) if present
  if (domainClean.startsWith('https://')) {
    domainClean = domainClean.slice(8);
  } else if (domainClean.startsWith('http://')) {
    domainClean = domainClean.slice(7);
  }

  // Remove trailing slashes
  domainClean = domainClean.replace(/\/+$/, '');

  // Wildcard subdomain: *.example.com (no port; matches any subdomain)
  const wildcardDomainPattern =
    /^\*\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

  // Standard domain: example.com or subdomain.example.com (with optional port)
  const standardDomainPattern =
    /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}(:\d+)?$/;

  // Localhost: localhost or 127.0.0.1 with optional port
  const localhostPattern = /^(localhost|127\.0\.0\.1)(:\d+)?$/;

  // IP address with optional port
  const ipWithPortPattern = /^(\d{1,3}\.){3}\d{1,3}(:\d+)?$/;

  // Check against all supported patterns
  const isValid =
    wildcardDomainPattern.test(domainClean) ||
    standardDomainPattern.test(domainClean) ||
    localhostPattern.test(domainClean) ||
    ipWithPortPattern.test(domainClean);

  return isValid;
};

export const convertImagesToPNG = async (file) => {
  const extension = file.name.split('.').pop().toLowerCase();
  const arrayBuffer = await file.arrayBuffer();
  return new Promise((resolve, reject) => {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (extension === 'tiff' || extension === 'tif') {
        // --- TIFF Logic ---
        const ifds = UTIF.decode(arrayBuffer);
        UTIF.decodeImage(arrayBuffer, ifds[0]);
        const rgba = UTIF.toRGBA8(ifds[0]);

        canvas.width = ifds[0].width;
        canvas.height = ifds[0].height;
        const imgData = ctx.createImageData(canvas.width, canvas.height);
        imgData.data.set(rgba);
        ctx.putImageData(imgData, 0, 0);

        canvas.toBlob((blob) => {
          const newFile = new File([blob], file.name.replace(/\.(tiff|tif)$/i, '.png'), {
            type: 'image/png',
          });
          resolve(newFile);
        }, 'image/png');
      } else {
        // If format is not handled, return original file
        resolve(convertToPNG(file));
      }
    } catch (err) {
      reject(err);
    }
  });
};

export const convertToPNG = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      canvas.getContext('2d').drawImage(img, 0, 0);

      canvas.toBlob((blob) => {
        resolve(
          new File([blob], file.name.replace(/\.\w+$/, '.png'), {
            type: 'image/png',
          })
        );
        URL.revokeObjectURL(url);
      }, 'image/png');
    };

    img.onerror = () => reject('Unsupported image format');
    img.src = url;
  });
};

export const detectImageTransparency = (imageSource) => {
  return new Promise((resolve) => {
    const img = typeof imageSource === 'string' ? new Image() : imageSource;

    const checkTransparency = () => {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;

      if (!width || !height) {
        resolve(false);
        return;
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(false);
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      try {
        const { data } = ctx.getImageData(0, 0, width, height);

        for (let i = 3; i < data.length; i += 4) {
          if (data[i] < 255) {
            resolve(true); // Transparency found
            return;
          }
        }

        resolve(false); // Fully opaque
      } catch (error) {
        // Likely CORS-tainted canvas
        console.warn('Transparency check failed (CORS):', error);
        resolve(false);
      }
    };

    if (typeof imageSource === 'string') {
      img.crossOrigin = 'anonymous';
      img.onload = checkTransparency;
      img.onerror = () => resolve(false);
      img.src = imageSource;
    } else if (img.complete) {
      checkTransparency();
    } else {
      img.onload = checkTransparency;
      img.onerror = () => resolve(false);
    }
  });
};

// Generate a random 4-digit number for confirmation dialogs
export const generateConfirmationNumber = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

/**
 * Whether the browser has room to store `bytes` more in origin storage (IndexedDB, Cache, etc.),
 * keeping `buffer` bytes free as headroom. Best-effort: returns true if it can't be measured
 * (older browsers / blocked API), so it never falsely blocks a save.
 *
 * @param {number} bytes  size we want to store
 * @param {number} buffer headroom to keep free (default 100 MB)
 */
export const hasEnoughStorageSpace = async (bytes = 0, buffer = 100 * 1024 * 1024) => {
  try {
    if (!navigator?.storage?.estimate) return true;
    const { quota = 0, usage = 0 } = await navigator.storage.estimate();
    return quota - usage > (bytes || 0) + buffer;
  } catch (_) {
    return true;
  }
};

// Format scope name: "product:create" -> "Product Create"
export const formatScopeName = (scopeName) => {
  if (!scopeName) return '';
  return scopeName
    .split(':')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};

// Create domain tag object with duplicate check
export const createDomainTag = (domain, existingDomains = [], currentTags = []) => {
  const domainName = typeof domain === 'object' ? domain.domain : domain;

  const isDuplicate =
    existingDomains.some((d) =>
      domainName.toLowerCase()?.split('/')?.includes(d.name.toLowerCase())
    ) || currentTags.some((t) => t.name.toLowerCase() === domainName.toLowerCase());

  const isInvalid = !isValidDomain(domainName);

  // Show warning toast for invalid domain
  if (isInvalid) {
    warningToast(`"${domainName}" is not a valid domain format.`);
  }

  return {
    id: uuidv4(),
    name: domainName,
    warning: isInvalid,
    isDuplicate,
  };
};

export const writeTextToClipboardSafely = async (text = "") => {
  const value = typeof text === "string" ? text : `${text ?? ""}`;

  const tryNativeClipboard = async () => {
    if (!navigator?.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(value);
    return true;
  };

  // Dropdown close/blur can briefly remove focus during click handlers.
  if (!document.hasFocus()) {
    for (let i = 0; i < 5 && !document.hasFocus(); i++) {
      await wait(75);
    }
  }

  try {
    const copied = await tryNativeClipboard();
    if (copied) return true;
  } catch (error) {
    // Fallback below uses legacy copy command.
  }

  const textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  textArea.style.pointerEvents = "none";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  const copied = document.execCommand("copy");
  textArea.remove();

  if (!copied) {
    throw new Error("Clipboard copy failed");
  }

  return true;
};



// Returns the 3D model file extension ('glb' | 'fbx') based on the URL.
// Defaults to 'glb' when the URL is missing or doesn't end with a known 3D extension.
export const get3DModelExtension = (url) => {
  if (!url) return 'glb';
  const cleanUrl = url.split('?')[0].toLowerCase();
  if (cleanUrl.endsWith('.fbx')) return 'fbx';
  return 'glb';
};

// True when the URL points to any supported 3D model file (GLB or FBX).
export const is3DModelUrl = (url) => {
  if (!url) return false;
  const cleanUrl = url.split('?')[0].toLowerCase();
  return cleanUrl.endsWith('.glb') || cleanUrl.endsWith('.fbx');
};

// Pick the first 3D model URL among the candidate fields of an asset/automation item.
export const pick3DModelUrl = (item) => {
  if (!item) return '';
  const candidates = [
    item.output_image,
    item.manual_output_image_path,
    item.input_image,
    item.manual_thumb_output_image_path,
    item.thumbnail_output_image,
    item.thumb,
    item.glb,
  ];
  return candidates.find((u) => is3DModelUrl(u)) || '';
};

// Extract file extension from a URL, handling query parameters and fragments.
// Returns extension with dot prefix (e.g., '.png') or empty string if not found.
export const getFileExtension = (fileUrl) => {
  if (!fileUrl) return '';

  const cleanUrl = fileUrl.split('?')[0].split('#')[0];
  const dotIndex = cleanUrl.lastIndexOf('.');
  if (dotIndex === -1) return '';

  const ext = cleanUrl.slice(dotIndex);
  return ext.length <= 8 ? ext : '';
};
